module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_c('scale-loader', {
    staticClass: "loader",
    attrs: {
      "loading": _vm.loading,
      "color": _vm.color,
      "width": _vm.width,
      "height": _vm.height
    }
  }), _vm._v(" "), (_vm.loading) ? _c('dimmer') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-275de40e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Loader.vue
// module id = 250
// module chunks = 0